import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.prompttests');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-prompttests',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.prompttests/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
  color: #172033;
}

.pt-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #f5f7fb;
  font: 13px/1.55 -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.pt-shell *, .pt-shell *::before, .pt-shell *::after {
  box-sizing: border-box;
}

.pt-shell h1, .pt-shell h2, .pt-shell h3, .pt-shell h4, .pt-shell p {
  margin: 0;
}

.pt-shell h1 {
  font-size: 20px;
  font-weight: 700;
}

.pt-shell h2 {
  font-size: 16px;
  font-weight: 650;
}

.pt-shell h3 {
  font-size: 15px;
  font-weight: 650;
}

.pt-shell h4 {
  font-size: 13px;
  font-weight: 650;
}

.pt-shell input, .pt-shell textarea, .pt-shell select, .pt-shell button {
  font: inherit;
}

.pt-shell button {
  cursor: pointer;
}

.pt-shell button:disabled {
  cursor: default;
  opacity: 0.5;
}

.pt-shell :is(button, a, input, textarea, select, summary):focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 3px;
}

.pt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  flex: 0 0 auto;
  padding: 21px 28px 18px;
  background: #fff;
  border-bottom: 1px solid #e0e6ef;
}

.pt-eyebrow {
  color: #567097;
  font-size: 10px;
  letter-spacing: 0.1em;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.pt-muted {
  color: #68758a;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.pt-header .pt-muted {
  margin-top: 4px;
}

.pt-header-actions, .pt-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.pt-heading {
  justify-content: space-between;
  margin-bottom: 10px;
}

.pt-heading .pt-muted {
  max-width: 70%;
}

.pt-link {
  color: #365a8a;
  text-decoration: none;
  white-space: nowrap;
}

.pt-button {
  display: inline-block;
  padding: 7px 12px;
  min-height: 34px;
  border: 1px solid #d6dfeb;
  border-radius: 7px;
  background: #fff;
  color: #314660;
  text-decoration: none;
  text-align: center;
}

.pt-button:not(:disabled):hover {
  background: #eef4fc;
}

.pt-primary {
  background: #20548d;
  border-color: #20548d;
  color: #fff;
}

.pt-primary:not(:disabled):hover {
  background: #174472;
}

.pt-workspace {
  display: grid;
  grid-template-columns: 236px minmax(0, 1fr);
  gap: 20px;
  flex: 1 1 auto;
  min-height: 0;
  margin: 20px 24px;
}

.pt-sidebar {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border: 1px solid #dce3ee;
  border-radius: 10px;
  overflow: hidden;
  background: #fbfcff;
}

.pt-sidebar-head {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 17px 16px 12px;
}

.pt-count, .pt-badge {
  display: inline-block;
  padding: 2px 7px;
  color: #5c6980;
  background: #edf1f7;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
}

.pt-count {
  border-radius: 12px;
  min-width: 22px;
  text-align: center;
}

.pt-badge.is-failed {
  background: #fff0ed;
  color: #a04437;
}

.pt-new {
  margin: 0 12px 10px;
}

.pt-sidebar-note {
  padding: 0 14px 12px;
  font-size: 11px;
}

.pt-experiments {
  overflow: auto;
  padding: 0 8px 12px;
  min-height: 0;
}

.pt-experiment {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
  padding: 11px 9px;
  margin-bottom: 5px;
  border: 1px solid transparent;
  border-radius: 7px;
  text-align: left;
  color: #314660;
  background: transparent;
}

.pt-experiment strong {
  flex: 1 0 100%;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.pt-experiment small {
  width: 100%;
  color: #77839a;
  font-size: 10px;
}

.pt-experiment:hover, .pt-question:hover {
  background: #f0f5fc;
}

.pt-experiment.is-selected, .pt-question.is-selected {
  border-color: #bfd3ef;
  background: #eaf2ff;
}

.pt-main {
  min-height: 0;
  min-width: 0;
  overflow: auto;
  padding-right: 3px;
}

.pt-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  border-bottom: 1px solid #dce3ee;
}

.pt-tabs button {
  padding: 8px 13px 12px;
  border: 0;
  border-bottom: 2px solid transparent;
  color: #68758a;
  background: transparent;
}

.pt-tabs button[aria-selected=true] {
  border-bottom-color: #20548d;
  color: #20548d;
  font-weight: 650;
}

.pt-card {
  border: 1px solid #dce3ee;
  border-radius: 9px;
  padding: 18px 20px;
  background: #fff;
  min-width: 0;
  margin-bottom: 16px;
}

.pt-policy {
  padding: 12px 14px;
  margin-bottom: 16px;
  border: 1px solid #d9e4f3;
  border-radius: 8px;
  background: #eef4fc;
  color: #456082;
  font-size: 12px;
}

.pt-policy strong {
  color: #264d7c;
}

.pt-policy p {
  margin-top: 3px;
}

.pt-shell summary {
  cursor: pointer;
  color: #4b6280;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.pt-shell details[open] > summary {
  margin-bottom: 9px;
}

.pt-shell pre {
  margin: 10px 0 0;
  padding: 12px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: #f7f9fd;
  border: 1px solid #e4e9f1;
  border-radius: 6px;
  font: 11px/1.8 ui-monospace, SFMono-Regular, Consolas, monospace;
  max-height: 360px;
  overflow: auto;
}

.pt-production {
  padding: 13px 18px;
}

.pt-production code {
  display: block;
  color: #8a96a8;
  font-size: 10px;
  margin-top: 9px;
  overflow-wrap: anywhere;
}

.pt-setup-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.pt-shell fieldset {
  min-width: 0;
  border: 0;
  padding: 0;
  margin: 0;
}

.pt-field {
  margin: 12px 0;
  min-width: 0;
}

.pt-field label, .pt-question-sidebar > label {
  display: block;
  color: #56657c;
  font-size: 12px;
  font-weight: 550;
  margin-bottom: 5px;
}

.pt-shell input, .pt-shell select, .pt-shell textarea {
  display: block;
  width: 100%;
  min-width: 0;
  padding: 7px 9px;
  border: 1px solid #cfd9e6;
  border-radius: 6px;
  background: #fff;
  color: #172033;
}

.pt-shell input[type=file] {
  font-size: 11px;
}

.pt-shell textarea {
  resize: vertical;
  line-height: 1.7;
}

.pt-field small {
  display: block;
  margin-top: 5px;
  font-size: 10px;
}

#pt-prompt-content, .pt-review textarea {
  font-family: ui-monospace, SFMono-Regular, Consolas, monospace;
  font-size: 12px;
}

.pt-file-list {
  padding-left: 18px;
  color: #68758a;
  font-size: 11px;
  overflow-wrap: anywhere;
}

.pt-dataset, .pt-saved-prompt {
  margin-top: 13px;
  border-top: 1px solid #e6ebf3;
  padding-top: 12px;
}

.pt-form-grid, .pt-review-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
}

.pt-wide {
  grid-column: 1/-1;
}

.pt-selected-prompt {
  padding: 5px 0;
}

.pt-setting-note {
  margin: 12px 0 !important;
}

.pt-message {
  padding: 10px 12px;
  margin: 0 0 14px;
  border: 1px solid;
  border-radius: 7px;
  overflow-wrap: anywhere;
}

.pt-shell > .pt-message {
  margin: 20px 24px;
}

.pt-message small {
  display: block;
  margin-top: 5px;
}

.pt-message .pt-button {
  margin-top: 8px;
}

.pt-error {
  background: #fff7f6;
  border-color: #edc7c5;
  color: #9c3c36;
}

.pt-notice {
  background: #f1faf6;
  border-color: #c7dfd6;
  color: #346d59;
}

.pt-warning {
  background: #fffaf0;
  border-color: #e7dfca;
  color: #776136;
  font-size: 12px;
  margin-top: 12px;
}

.pt-warning-text {
  color: #8a6a32;
  font-size: 11px;
  margin-top: 6px !important;
}

.pt-progress-label {
  display: flex;
  justify-content: space-between;
  color: #68758a;
  font-size: 12px;
  margin-top: 15px;
}

.pt-progress {
  display: block;
  width: 100%;
  height: 7px;
  margin: 7px 0 16px;
  accent-color: #20548d;
}

.pt-run-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.pt-export {
  margin-left: auto;
}

.pt-export + .pt-export {
  margin-left: 0;
}

.pt-integrity {
  color: #8a96a8;
  margin-top: 12px;
}

.pt-comparison-layout {
  display: grid;
  grid-template-columns: 206px minmax(0, 1fr);
  border: 1px solid #dce3ee;
  border-radius: 9px;
  background: #fff;
  overflow: hidden;
}

.pt-question-sidebar {
  padding: 14px 10px;
  border-right: 1px solid #e0e6ef;
  background: #fbfcff;
  min-width: 0;
}

.pt-questions {
  margin-top: 12px;
  max-height: 720px;
  overflow: auto;
}

.pt-question {
  display: block;
  width: 100%;
  margin-bottom: 6px;
  padding: 10px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  text-align: left;
  color: #4b5c73;
}

.pt-question strong {
  display: block;
  font-size: 11px;
  font-weight: 500;
  margin-top: 5px;
  overflow-wrap: anywhere;
}

.pt-comparison {
  min-width: 0;
  padding: 18px;
}

.pt-question-title h2 {
  margin-top: 5px;
  font-size: 15px;
  overflow-wrap: anywhere;
}

.pt-reference, .pt-documents {
  margin-top: 16px;
  padding: 12px;
  border: 1px solid #e1e7f0;
  border-radius: 7px;
}

.pt-preserve {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  color: #4b5c73;
  font-size: 12px;
}

.pt-document {
  margin-top: 13px;
  font-size: 11px;
  color: #4b6280;
  overflow-wrap: anywhere;
}

.pt-answer-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 18px;
}

.pt-answer {
  min-width: 0;
}

.pt-answer .pt-heading {
  border-bottom: 2px solid #dce7f5;
  padding-bottom: 8px;
}

.pt-answer-text {
  min-height: 120px;
  max-height: 500px !important;
  color: #334861;
  background: #fbfcff !important;
  font-size: 12px !important;
}

.pt-auto {
  margin-top: 12px;
}

.pt-review {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #e3e9f1;
}

.pt-review > .pt-muted {
  margin-top: 5px;
  font-size: 10px;
}

.pt-review-fields {
  gap: 0 10px;
}

.pt-review-fields .pt-field {
  margin-bottom: 0;
}

.pt-review-fields label {
  font-size: 11px;
}

.pt-example {
  display: block;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 9px;
  margin-top: 6px;
  color: #8a96a8;
}

.pt-empty {
  padding: 28px 15px;
  text-align: center;
  color: #8a96a8;
  font-size: 12px;
}

.pt-metrics > .pt-muted {
  margin-top: 6px;
}

.pt-table-wrap {
  overflow: auto;
  margin-top: 18px;
}

.pt-shell table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 12px;
}

.pt-shell th, .pt-shell td {
  padding: 11px 12px;
  border-bottom: 1px solid #e1e7f0;
  vertical-align: top;
}

.pt-shell th {
  font-weight: 600;
  color: #4b6280;
  background: #f7f9fc;
}

.pt-summary td small {
  display: block;
  margin-top: 3px;
  font-size: 10px;
}

.pt-summary th {
  min-width: 145px;
}

.pt-summary td {
  min-width: 105px;
}

.pt-shell td {
  color: #68758a;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

@media (max-width: 1180px) {
  .pt-workspace {
    grid-template-columns: 205px minmax(0, 1fr);
    gap: 14px;
  }
  .pt-comparison-layout {
    grid-template-columns: 170px minmax(0, 1fr);
  }
  .pt-answer-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .pt-comparison {
    padding: 14px;
  }
  .pt-card {
    padding: 16px;
  }
}
@media (max-width: 940px) {
  .pt-setup-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }
  .pt-comparison-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .pt-question-sidebar {
    border-right: 0;
    border-bottom: 1px solid #e0e6ef;
  }
  .pt-questions {
    max-height: 200px;
  }
}
@media (max-width: 760px) {
  :host {
    overflow-y: auto;
    overflow-x: hidden;
  }
  .pt-shell {
    height: auto;
    min-height: 100%;
  }
  .pt-header {
    padding: 17px 16px;
    align-items: flex-start;
  }
  .pt-header h1 {
    font-size: 18px;
  }
  .pt-header-actions {
    flex-direction: column;
    align-items: flex-end;
    font-size: 11px;
    gap: 7px;
    flex-shrink: 0;
  }
  .pt-workspace {
    display: block;
    flex: none;
    margin: 12px;
  }
  .pt-sidebar {
    margin-bottom: 15px;
  }
  .pt-experiments {
    max-height: 190px;
  }
  .pt-main {
    overflow: visible;
    padding: 0;
  }
  .pt-tabs {
    gap: 0;
  }
  .pt-tabs button {
    flex: 1;
    padding: 9px 5px;
  }
  .pt-card {
    padding: 15px 13px;
  }
  .pt-form-grid {
    column-gap: 10px;
  }
  .pt-heading .pt-muted {
    max-width: 100%;
  }
  .pt-run-actions .pt-button {
    flex: 1 0 auto;
    font-size: 11px;
  }
  .pt-export {
    margin-left: 0;
  }
  .pt-comparison {
    padding: 13px;
  }
  .pt-shell > .pt-message {
    margin: 12px;
  }
  .pt-metrics th, .pt-metrics td {
    padding: 8px;
    min-width: 90px;
  }
}
.pt-public-note {
  margin-top: 14px;
  margin-bottom: 0;
}

.pt-prompt-pair {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 14px;
}

.pt-prompt-variant {
  min-width: 0;
  border: 1px solid #e1e7f0;
  border-radius: 7px;
  padding: 12px;
}

.pt-question-count {
  margin-bottom: 12px !important;
  color: #365a8a;
  font-size: 12px;
  font-weight: 600;
}

@media (max-width: 940px) {
  .pt-prompt-pair {
    grid-template-columns: minmax(0, 1fr);
  }
}`],
})
export class PagePrompttestsComponent implements OnInit, OnDestroy {
    public prompts: any[] = [];
    public datasets: any[] = [];
    public experiments: any[] = [];
    public production: any = null;
    public metrics: any[] = [];
    public models: any[] = [];
    public detail: any = null;
    public canManage = false;
    public loading = true;
    public detailLoading = false;
    public busy = '';
    public error = '';
    public actionError = '';
    public notice = '';
    public tab = 'setup';
    public promptEditor = {name: '', content: ''};
    public datasetName = '';
    public seed = '20261023';
    public files: File[] = [];
    public experimentForm: any = {name: '', datasetId: '', promptAId: '', promptBId: '',
        settings: {modelId: '', temperature: 0.2, top_p: 0.9, max_tokens: 2048, topK: 5, mode: 'hybrid'}};
    public selectedQuestionId = '';
    public questionFilter = 'all';
    public running = false;
    public pauseRequested = false;
    public reviews: any = {A: {}, B: {}};
    public reviewErrors: any = {A: '', B: ''};
    public readonly evidenceExample = JSON.stringify([{sentence: '검수할 문장', documentIds: ['문서ID'], verdict: 'supported'}]);
    public readonly variants = ['A', 'B'];
    public readonly qualityMetrics = [
        {id: 'technical_accuracy', label: '기술 정확성'},
        {id: 'groundedness', label: '근거 충실도'},
        {id: 'hallucination', label: '환각 점수'},
        {id: 'completeness', label: '답변 완성도'},
        {id: 'terminology', label: '용어 일관성'}
    ];
    private destroyed = false;
    private requestId = 0;
    private uploadController: AbortController | null = null;

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        try {
            await this.service.init();
            await this.load();
        } catch (error) {
            this.error = '실험 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.';
            this.loading = false;
            await this.render();
        }
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.pauseRequested = true;
        this.requestId++;
        this.uploadController?.abort();
    }

    private async render() { if (!this.destroyed) await this.service.render(); }
    public async changed() { await this.render(); }
    public async selectTab(tab: string) {
        if (tab === 'setup' && !this.canManage) return;
        this.tab = tab;
        await this.render();
    }
    public display(value: any): string {
        if (value === undefined || value === null || value === '') return '미기록';
        return typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value);
    }
    public decimal(value: any, digits = 1): string {
        return value === null || value === undefined || !Number.isFinite(Number(value)) ? '미집계' : Number(value).toFixed(digits);
    }
    public percent(value: any): string {
        return value === null || value === undefined || !Number.isFinite(Number(value)) ? '미검수' : (Number(value) * 100).toFixed(1) + '%';
    }
    public date(value: string): string {
        if (!value) return '—';
        const parsed = new Date(value);
        return Number.isNaN(parsed.getTime()) ? value : parsed.toLocaleString('ko-KR');
    }
    public status(value: string): string {
        return ({prepared: '준비 완료', ready: '준비', pending: '대기', running: '실행 중', completed: '완료',
            failed: '실패', paused: '일시 정지', partial: '일부 완료'} as any)[value] || value || '대기';
    }
    public promptLabel(prompt: any): string { return prompt ? prompt.name + ' · v' + prompt.version : '선택 없음'; }
    public findPrompt(id: string): any { return this.prompts.find(item => item.id === id); }
    public get selectedDataset(): any { return this.datasets.find(item => item.id === this.experimentForm.datasetId); }
    public get selectedQuestion(): any {
        return this.detail?.questions?.find(item => item.id === this.selectedQuestionId) || null;
    }
    public get selectedResult(): any {
        return this.detail?.results?.find(item => item.questionId === this.selectedQuestionId) || null;
    }
    public resultFor(id: string): any { return this.detail?.results?.find(item => item.questionId === id); }
    public get filteredQuestions(): any[] {
        return (this.detail?.questions || []).filter(item => this.questionFilter === 'all'
            || (this.resultFor(item.id)?.status || 'pending') === this.questionFilter);
    }
    public get progress(): number {
        const item = this.detail?.experiment;
        return item?.total ? Math.min(100, Math.round(((item.completed || 0) + (item.failed || 0)) / item.total * 100)) : 0;
    }
    public get canEditExperiment(): boolean {
        return this.canManage && !!this.detail?.experiment && this.detail.experiment.readOnly !== true;
    }
    public get canRun(): boolean {
        const item = this.detail?.experiment;
        return this.canEditExperiment && !!item && !this.detailLoading && !this.busy && !this.running
            && Number(item.completed || 0) < Number(item.total);
    }
    private message(response: any, fallback: string): string {
        if (Number(response?.code) === 401) return '로그인 후 다시 시도해 주세요.';
        if (Number(response?.code) === 403) return '프롬프트 테스트 관리 권한이 없습니다.';
        return response?.data?.message || response?.message || fallback;
    }
    private csrf(): string {
        const token = this.service.auth.session?.chat_csrf;
        if (!token) throw new Error('로그인 세션을 확인하지 못했습니다. 입력을 보관하고 다시 로그인해 주세요.');
        return token;
    }
    private async request(action: string, values: any = {}, write = false): Promise<any> {
        if (write && !this.canManage) throw new Error('이 화면에서는 공개된 실험을 조회할 수 있습니다.');
        const response = await wiz.call(action, write ? {...values, chat_csrf_token: this.csrf()} : values);
        if (Number(response?.code) !== 200) throw new Error(this.message(response, '요청을 처리하지 못했습니다.'));
        return response.data;
    }
    private applyOverview(data: any) {
        this.canManage = data?.access?.canManage === true;
        if (!this.canManage && this.tab === 'setup') this.tab = 'results';
        this.prompts = data?.prompts || [];
        this.datasets = data?.datasets || [];
        this.experiments = data?.experiments || [];
        this.production = data?.production || null;
        this.metrics = data?.metrics || [];
        this.models = data?.models || [];
        if (!this.experimentForm.datasetId && this.datasets.length) this.experimentForm.datasetId = this.datasets[0].id;
        if (!this.experimentForm.promptAId && this.prompts.length) this.experimentForm.promptAId = this.prompts[0].id;
        if (!this.experimentForm.promptBId && this.prompts.length > 1) this.experimentForm.promptBId = this.prompts[1].id;
    }
    public async load() {
        if (this.busy || this.running || this.destroyed) return;
        this.loading = true;
        this.error = '';
        await this.render();
        try {
            const data = await this.request('overview');
            if (!this.destroyed) {
                this.applyOverview(data);
                const selectedId = this.detail?.experiment?.id;
                if (selectedId && !this.experiments.some(item => item.id === selectedId)) this.detail = null;
                const targetId = this.detail?.experiment?.id || data?.featuredExperimentId
                    || (!this.canManage ? this.experiments[0]?.id : '');
                if (targetId) await this.selectExperiment(targetId);
            }
        } catch (error) {
            if (!this.destroyed) this.error = error.message || '목록을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.render();
        }
    }

    public async savePrompt() {
        if (!this.canManage || this.busy || this.running) return;
        this.actionError = '';
        this.notice = '';
        if (!this.promptEditor.name.trim() || !this.promptEditor.content.trim()) {
            this.actionError = '프롬프트 이름과 내용을 입력해 주세요.';
            await this.render();
            return;
        }
        this.busy = 'prompt';
        await this.render();
        try {
            const saved = await this.request('save_prompt', {payload: JSON.stringify(this.promptEditor)}, true);
            if (this.destroyed) return;
            this.promptEditor = {name: '', content: ''};
            this.applyOverview(await this.request('overview'));
            this.experimentForm.promptBId = saved.id;
            this.notice = this.promptLabel(saved) + '을 저장했습니다.';
        } catch (error) { if (!this.destroyed) this.actionError = error.message; }
        finally { this.busy = ''; await this.render(); }
    }
    public async filesChanged(event: any) {
        this.files = Array.from(event.target.files || []);
        await this.render();
    }
    public async importDataset() {
        if (!this.canManage || this.busy || this.running) return;
        this.actionError = '';
        this.notice = '';
        if (!this.files.length) {
            this.actionError = '질의·기준 답변 파일을 선택해 주세요. JSONL, ShareGPT JSON, XLSX를 지원합니다.';
            await this.render();
            return;
        }
        this.busy = 'dataset';
        this.uploadController = new AbortController();
        await this.render();
        try {
            const form = new FormData();
            this.files.forEach(file => form.append('file[]', file, file.name));
            form.append('name', this.datasetName.trim() || '평가 질문 100개');
            form.append('seed', this.seed);
            form.append('chat_csrf_token', this.csrf());
            const response = await fetch('/wiz/api/page.prompttests/import_dataset', {
                method: 'POST', credentials: 'same-origin', body: form, signal: this.uploadController.signal
            });
            const body = await response.json();
            if (Number(body?.code) !== 200) throw new Error(this.message(body, '질의 파일을 가져오지 못했습니다.'));
            if (this.destroyed) return;
            this.applyOverview(await this.request('overview'));
            this.experimentForm.datasetId = body.data.id;
            this.notice = body.data.count + '개 질문을 선택하고 원본과 추출 기준을 보관했습니다.';
        } catch (error) {
            if (!this.destroyed) this.actionError = error.message || '파일 업로드에 실패했습니다.';
        } finally { this.busy = ''; this.uploadController = null; await this.render(); }
    }
    public async createExperiment() {
        if (!this.canManage || this.busy || this.running) return;
        this.actionError = '';
        this.notice = '';
        const form = this.experimentForm;
        if (!form.name.trim() || !form.datasetId || !form.promptAId || !form.promptBId) {
            this.actionError = '실험 이름, 질문 세트, 프롬프트 A와 B를 모두 선택해 주세요.';
            await this.render(); return;
        }
        if (form.promptAId === form.promptBId) {
            this.actionError = '서로 다른 프롬프트 버전을 A와 B로 선택해 주세요.';
            await this.render(); return;
        }
        this.busy = 'create';
        await this.render();
        try {
            const data = await this.request('create_experiment', {payload: JSON.stringify(form)}, true);
            if (this.destroyed) return;
            this.applyDetail(data);
            this.tab = 'results';
            this.applyOverview(await this.request('overview'));
            this.notice = '실험을 생성했습니다. 실행을 시작하면 실제 RAG 검색과 모델 호출이 진행됩니다.';
        } catch (error) { if (!this.destroyed) this.actionError = error.message; }
        finally { this.busy = ''; await this.render(); }
    }
    private applyDetail(data: any) {
        this.detail = data;
        const questions = data?.questions || [];
        if (!questions.some(item => item.id === this.selectedQuestionId)) this.selectedQuestionId = questions[0]?.id || '';
        this.resetReviews();
        const item = data?.experiment;
        if (item) this.experiments = [item, ...this.experiments.filter(existing => existing.id !== item.id)];
    }
    public async selectExperiment(id: string) {
        if (this.running || this.busy) return;
        const requestId = ++this.requestId;
        this.detailLoading = true;
        this.actionError = '';
        this.notice = '';
        this.tab = 'results';
        await this.render();
        try {
            const data = await this.request('detail', {experiment_id: id});
            if (!this.destroyed && requestId === this.requestId) this.applyDetail(data);
        } catch (error) { if (!this.destroyed && requestId === this.requestId) this.actionError = error.message; }
        finally { if (requestId === this.requestId) { this.detailLoading = false; await this.render(); } }
    }
    public async selectQuestion(id: string) {
        if (this.busy === 'review') return;
        this.selectedQuestionId = id;
        this.resetReviews();
        await this.render();
    }
    private resetReviews() {
        for (const variant of this.variants) {
            const saved = this.selectedResult?.answers?.[variant]?.review || {};
            this.reviews[variant] = {...saved, sentenceEvidenceText: JSON.stringify(saved.sentenceEvidence || [], null, 2),
                satisfaction: saved.satisfaction ?? null, comment: saved.comment || ''};
            this.qualityMetrics.forEach(metric => this.reviews[variant][metric.id] = saved[metric.id] ?? null);
        }
        this.reviewErrors = {A: '', B: ''};
    }
    public async pause() {
        this.pauseRequested = true;
        this.notice = '현재 질문의 A/B 생성이 끝나면 정지합니다. 완료된 결과는 유지됩니다.';
        await this.render();
    }
    public async run(automatic: boolean) {
        if (!this.canRun) return;
        this.running = true;
        this.pauseRequested = false;
        this.busy = 'run';
        this.actionError = '';
        this.notice = '';
        await this.render();
        try {
            do {
                const previous = this.detail.experiment;
                const previousCount = Number(previous.completed || 0);
                const data = await this.request('run_next', {experiment_id: previous.id}, true);
                if (this.destroyed) return;
                this.applyDetail(data);
                const current = data.experiment;
                const count = Number(current.completed || 0);
                await this.render();
                if (Number(current.failed || 0) > 0) {
                    this.actionError = '질문 처리 중 오류가 발생하여 자동 실행을 멈췄습니다. 실패 질문의 오류를 확인한 뒤 다시 실행하면 해당 질문부터 재시도합니다.';
                    break;
                }
                if (count >= Number(current.total)) {
                    this.notice = '모든 질문 처리가 끝났습니다. 사람 검수와 비교표를 확인하세요.';
                    break;
                }
                if (count <= previousCount) {
                    this.actionError = '처리 진척이 확인되지 않아 자동 실행을 멈췄습니다. 실험을 다시 조회해 주세요.';
                    break;
                }
                if (!automatic || this.pauseRequested) {
                    this.notice = '실행을 멈췄습니다. 이어서 실행하면 남은 질문부터 처리합니다.';
                    break;
                }
            } while (!this.destroyed && !this.pauseRequested);
        } catch (error) {
            if (!this.destroyed) this.actionError = (error.message || '실행에 실패했습니다.')
                + ' 완료 여부를 다시 조회한 후 이어서 실행하세요.';
        } finally { this.running = false; this.busy = ''; await this.render(); }
    }
    public async saveReview(variant: string) {
        if (!this.canEditExperiment || this.busy || this.running || !this.selectedResult?.answers?.[variant]) return;
        this.reviewErrors[variant] = '';
        const editor = this.reviews[variant];
        let sentenceEvidence: any;
        try {
            sentenceEvidence = JSON.parse(editor.sentenceEvidenceText || '[]');
            if (!Array.isArray(sentenceEvidence)) throw new Error();
            const documentIds = new Set((this.selectedResult.documents || []).map(item => String(item.id)));
            for (const row of sentenceEvidence) {
                if (!row || typeof row.sentence !== 'string' || !row.sentence.trim() || !Array.isArray(row.documentIds)
                    || row.documentIds.some(id => !documentIds.has(String(id)))
                    || !['supported', 'unsupported', 'uncertain'].includes(row.verdict)) throw new Error();
            }
        } catch (error) {
            this.reviewErrors[variant] = '문장별 근거 JSON과 문서 ID를 확인해 주세요.';
            await this.render(); return;
        }
        const review: any = {sentenceEvidence, comment: String(editor.comment || ''), satisfaction: editor.satisfaction};
        this.qualityMetrics.forEach(metric => review[metric.id] = editor[metric.id]);
        const otherVariant = variant === 'A' ? 'B' : 'A';
        const otherDraft = {...this.reviews[otherVariant]};
        this.busy = 'review';
        this.notice = '';
        await this.render();
        try {
            const data = await this.request('save_review', {experiment_id: this.detail.experiment.id,
                payload: JSON.stringify({questionId: this.selectedQuestionId, variant, review})}, true);
            if (this.destroyed) return;
            this.applyDetail(data);
            this.reviews[otherVariant] = otherDraft;
            this.notice = '답변 ' + variant + '의 사람 검수를 저장했습니다.';
        } catch (error) { if (!this.destroyed) this.reviewErrors[variant] = error.message; }
        finally { this.busy = ''; await this.render(); }
    }
    public exportUrl(format: string): string {
        return '/wiz/api/page.prompttests/export?experiment_id='
            + encodeURIComponent(this.detail?.experiment?.id || '') + '&format=' + encodeURIComponent(format);
    }
}

export default PagePrompttestsComponent;